import React, {FC, MouseEvent, useEffect, useState}  from 'react';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton} from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon } from '@mui/icons-material';

// import { ArgumentAxis, ValueAxis, BarSeries,
//   Chart, LineSeries, PieSeries, } from '@devexpress/dx-react-chart-material-ui';

//import { ValueScale } from '@devexpress/dx-react-chart';
  
// import library.
import {useQuery,useQueryClient, QueryClient, QueryClientProvider } from "react-query";
//import { Pie, Bar, defaults } from 'react-chartjs-2';

import Chart from 'react-apexcharts'

//import {Chart} from 'chart.js';

import { useTranslation  } from 'react-i18next';
// import user Component

// import user Library.
import {useUserStore} from '../library/store'; 

import useBankUserService from '../component/crm/service/BankUser';
//import { BubbleDataPoint, ChartData, ScatterDataPoint } from 'chart.js';

interface IDataItem {
  month: string,
  sale: number,
  total: number,
}

const chartData: IDataItem[] = [
  { month: 'Jan', sale: 50, total: 987 },
  { month: 'Feb', sale: 100, total: 3000 },
  { month: 'March', sale: 30, total: 1100 },
  { month: 'April', sale: 107, total: 7100 },
  { month: 'May', sale: 95, total: 4300 },
  { month: 'June', sale: 150, total: 7500 },
];




interface IUserDashboard {
  policies95: {agencyCode: string, agencyName: string, count: number}[],
  policies10: {agencyCode: string, agencyName: string, count: number}[],

  policies9510: {agencyCode: string, agencyName: string, 
      countBankPolicy95: number, countBankPolicy10: number, countPolicy10: number}[],

  yearTurnOver: {agencyCode: string, agencyName: string, turnOver: number}[]
}

const HomeForm: FC = () => {

  const { t, i18n } = useTranslation();

  const { setCurrentEntity} = useUserStore();

  const {getDashboard} = useBankUserService();

  const {isSuccess, status, data} = useQuery<IUserDashboard>(["dashboard", (new Date()).getMinutes() ],getDashboard);

  const [policies95, setPolicies95] = useState<{agencyCode: string, agencyName: string, count: number}[]>([]);

  const [apexOptionsPolicies95, setApexOptionsPolicies95] = useState<any>();

  // random number generator
  const rand = (frm: number, to: number) => ~~(Math.random() * (to - frm)) + frm;

  const arrayColorsGenerator = (len: number): string[] => {
    var colors: string[] = [];
    while (colors.length < len) 
      colors.push(`rgba(${rand(0, 255)}, ${rand(0, 255)}, ${rand(0, 255)}, 0.2)`);
    
    return colors;
  }

  
  
  
  

  // const [dataPolicies95, setDataPolicies95] = 
  //   useState<ChartData<"pie", (number | ScatterDataPoint | BubbleDataPoint | null)[], unknown>>(
  //     {
  //       labels:[], datasets: []
  //     }
  //   );

  // const [dataPolicies10, setDataPolicies10] = 
  //   useState<ChartData<"pie", (number | ScatterDataPoint | BubbleDataPoint | null)[], unknown>>(
  //     {
  //       labels:[], datasets: []
  //     }
  //   );

  useEffect( () => {
    setCurrentEntity('');

  }, [] );

  useEffect( () => {
    if(data) {
      setPolicies95(data?.policies95);

      
      // setDataPolicies95(
      //   {
      //     labels: data? data?.policies95.map( x => x.agencyName) : [] ,
      //     datasets: [
      //       {
      //         //label: '# of Votes',
      //         data:data? data?.policies95.map( x => x.count) : [],
      //         backgroundColor: arrayColorsGenerator(data? data?.policies95.length: 1),
      //         // backgroundColor: [
      //         //   'rgba(255, 99, 132, 0.2)',
      //         //   'rgba(54, 162, 235, 0.2)',
      //         //   'rgba(255, 206, 86, 0.2)',
      //         //   'rgba(75, 192, 192, 0.2)',
      //         //   'rgba(153, 102, 255, 0.2)',
      //         //   'rgba(255, 159, 64, 0.2)',
      //         // ],
              
      //         borderWidth: 1,
      //       },
      //     ],
      //   }
      // );

      // setDataPolicies10(
      //   {
      //     labels: data? data?.policies10.map( x => x.agencyName) : [] ,
      //     datasets: [
      //       {
      //         label: '# of Votes',
      //         data:data? data?.policies10.map( x => x.count) : [],
      //         backgroundColor: arrayColorsGenerator(data? data?.policies10.length: 1),
      //         // backgroundColor: [
      //         //   'rgba(255, 99, 132, 0.2)',
      //         //   'rgba(54, 162, 235, 0.2)',
      //         //   'rgba(255, 206, 86, 0.2)',
      //         //   'rgba(75, 192, 192, 0.2)',
      //         //   'rgba(153, 102, 255, 0.2)',
      //         //   'rgba(255, 159, 64, 0.2)',
      //         // ],
              
      //         borderWidth: 1,
      //       },
      //     ],
      //   }
      // );
    }

  }, [data] );

  const saveBankPolicy = async (event: MouseEvent<HTMLButtonElement>) => {
    
  }

  const dataRpt = {
    labels: data? data?.policies95.map( x => x.agencyName) : [] ,
    datasets: [
      {
        label: '# of Votes',
        data:data? data?.policies95.map( x => x.count) : [],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderWidth: 1,
      },
    ],
  };

  useEffect( () => {
    setCurrentEntity('');

  }, [] );
  

  const dataTmp = {
    labels: policies95.map( x => x.agencyName) ,
    datasets: [
      {
        label: '# of Votes',
        data: policies95.map( x => x.count),
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // const _optionsPolicies95 = {
  //   series: 
  // }

  const _options =  {
    chart: {
      id: 'apexchart-example'
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
    }
  }

  const _series =  [{
    name: 'series-1',
    data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
  }]



    

    return (
      <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
              <Grid item xs={12} sm={6} md={6} component={Paper} elevation={0} square>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '100%', height:'50vh' }} >              
                   
                                          
                  </Box>
                  <Box sx={{ mt: 1, width: '100%', height:'50vh' }} >
                    {/* <Chart options={_options} series={_series} type="bar" width='100%' height='320' /> */}
                    {/* <Bar data={ {
                      labels: data? data?.yearTurnOver.map( x => x.agencyName) : [],
                      datasets:[ 
                        {
                          //label: t('Turn Over'),
                          data: data? data?.yearTurnOver.map( x => x.turnOver) : [],
                          backgroundColor: 'green'
                        } ]                        
                       }}
                       
                       options={{
                        plugins: {
                          title: {
                            display: true,
                            text: t('Turn Over')
                          },
                          legend: {
                            display: false,
                            //position: "top"
                          }
                        }                        
                     }}/>  */}
                  </Box>
                </Box>  
              </Grid>
              <Grid item xs={12} sm={6} md={6} component={Paper} elevation={0} square>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '100%', height:'50vh' }} >  
                    {/* <Pie data={dataPolicies10} width={50} height={100} options={{
                        maintainAspectRatio: false,  
                        plugins : {
                          legend: {
                            display: true,
                            //position: "top"
                          },
                          title: {
                            display: true,
                            text: `${t('Validated policies')} , Total : ${dataPolicies10.datasets.reduce( (tot, dataset) => tot + (dataset.data.map( x => parseFloat(x? x.toString():'1') ).reduce( (t,count) => t + count,0) ) ,0)  }`
                          },                          
                        }    
                      }}/> */}
                  </Box>
                  <Box sx={{ mt: 1, width: '100%', height:'50vh' }} >  
                    {/* <Bar data={ {datasets:[ 
                        { label: t('Transmited'), data: data? data?.policies9510.map( x => x.countPolicy10) : [], backgroundColor:'green' }, 
                        { label: t('Validated'), data: data? data?.policies9510.map( x => x.countBankPolicy10) : [], backgroundColor:'aqua' },
                        { label: t('Unvalidated'), data: data? data?.policies9510.map( x => x.countBankPolicy95) : [], backgroundColor:'blue' }],
                        labels: data? data?.policies9510.map( x => x.agencyName) : [] } }
                        options={{
                          plugins: {
                            title: {
                              display: true,
                              text: t('Production count per agency')
                            }
                          },
                          scales: {
                               x: {
                                   stacked: true
                               },
                               y: {
                                   stacked: true
                               }
                           }
                       }} />  */}
                  </Box>
                </Box>
              </Grid>            
          </Grid>

      
    );
  }
  
  export default HomeForm;